// 统一"未登录"占位页 (动物之森风格)
// 用法: <NotLoggedIn /> 默认使用登录页浅灰底色; 自定义模块仍可传入背景与波点强调色
// 替换原来每页复制的 100vh+波点背景 代码块, 消灭重复 + 统一视觉
import { Button } from "animal-island-ui"

interface NotLoggedInProps {
  bg?: string
  accent?: string
  text?: string
}

export default function NotLoggedIn({
  bg = "#e8e8e8",
  accent,
  text = "var(--leaf-900)",
}: NotLoggedInProps) {
  return (
    <div
      className="flex min-h-[100dvh] w-full items-center justify-center"
      style={{
        backgroundColor: bg,
        backgroundImage: accent ? `radial-gradient(${accent}33 1.5px, transparent 1.5px)` : "none",
        backgroundSize: "20px 20px",
      }}
    >
      <div className="text-center">
        <div className="mb-4 font-medium" style={{ color: text }}>
          请先登录
        </div>
        <Button onClick={() => (window.location.href = "/")}>
          返回登录
        </Button>
      </div>
    </div>
  )
}
